module.exports = __webpack_public_path__ + "img/pro_two_11.455b7c52.jpg";